module.exports = __webpack_public_path__ + "media/images/diy/picture_bg_mobile-aa72c5b3d6159e2232c3ecdb632a6c74.png";